import { useParams } from "react-router-dom";
import DefaultHeader from "../components/default-header";
import DefaultFooter from "../components/default-footer";
import Slider from "react-slick";
import blogsData from "./../data/blogs";
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

const BlogSingle = () => {
  useEffect(() => {
    AOS.init({ duration: 900, once: true });
  }, []);

  const { id } = useParams<{ id: string }>();
  const blog = blogsData.find((item) => item.id === Number(id)) || blogsData[0];

  const socialContent = [
    { id: 1, icon: "icon-facebook", link: "http://facebook.com/", label: "Facebook" },
    { id: 2, icon: "icon-twitter", link: "http://twitter.com/", label: "Twitter" },
    { id: 3, icon: "icon-instagram", link: "http://instagram.com/", label: "Instagram" },
    { id: 4, icon: "icon-linkedin", link: "http://linkedin.com/", label: "LinkedIn" },
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400;1,600&family=Jost:wght@300;400;500;600&display=swap');

        .bs-page { background: #fff; color: #2d3f48; }

        /* HERO */
        .bs-hero {
          position: relative; width: 100%;
          height: 480px; overflow: hidden;
          display: flex; align-items: flex-end;
        }
        .bs-hero__img {
          position: absolute; inset: 0;
          width: 100%; height: 100%;
          object-fit: cover; filter: brightness(0.38);
        }
        .bs-hero__overlay {
          position: absolute; inset: 0;
          background: linear-gradient(to top, rgba(26,47,56,0.92) 0%, rgba(41,75,90,0.4) 60%, transparent 100%);
        }
        .bs-hero__content {
          position: relative; z-index: 2;
          width: 100%; padding: 0 0 56px;
        }
        .bs-hero__tag {
          display: inline-flex; align-items: center; gap: 8px;
          font-size: 10px; font-weight: 600; 
          color: #D3BE76;
          margin-bottom: 14px;
        }
        .bs-hero__tag::before {
          content: ''; width: 28px; height: 1.5px; background: #D3BE76; display: block;
        }
        .bs-hero h1 {
          font-size: clamp(32px, 4.5vw, 56px);
          font-weight: 700; color: #fff; line-height: 1.15;
          margin: 0 0 16px; max-width: 760px;
        }
        .bs-hero__meta {
          display: flex; align-items: center; gap: 24px;
          font-size: 13px; color: rgba(255,255,255,0.55);
        }
        .bs-hero__meta-dot {
          width: 4px; height: 4px; border-radius: 50%;
          background: #D3BE76; display: inline-block;
        }

        /* LAYOUT */
        .bs-layout { padding: 72px 0 100px; }
        .bs-content { max-width: 100%; }

        /* ARTICLE BODY */
        .bs-body h3 {
          font-size: 26px; font-weight: 700;
          color: #1a2f38; margin: 36px 0 14px;
        }
        .bs-body p {
          font-size: 15.5px; line-height: 1.85;
          color: #4a6370; margin-bottom: 20px;
        }
        .bs-body ul {
          list-style: none; padding: 0; margin: 0 0 20px;
        }
        .bs-body ul li {
          font-size: 15px; color: #4a6370; line-height: 1.75;
          padding: 6px 0 6px 22px; position: relative;
        }
        .bs-body ul li::before {
          content: ''; position: absolute; left: 0; top: 14px;
          width: 8px; height: 1.5px; background: #D3BE76;
        }

        /* BLOCKQUOTE */
        .bs-quote {
          margin: 36px 0; padding: 32px 36px;
          background: #f7f9fb;
          border-left: 4px solid #D3BE76;
          border-radius: 0 12px 12px 0;
          position: relative;
        }
        .bs-quote__mark {

          font-size: 72px; line-height: 1;
          color: #D3BE76; position: absolute;
          top: 10px; left: 28px; opacity: 0.4;
        }
        .bs-quote p {

          font-size: 21px; font-style: italic;
          color: #1a2f38; line-height: 1.6;
          margin: 0; padding-top: 16px;
        }

        /* INLINE IMAGES */
        .bs-img-grid {
          display: grid; grid-template-columns: 1fr 1fr;
          gap: 20px; margin: 32px 0;
        }
        .bs-img-grid figure { margin: 0; }
        .bs-img-grid img {
          width: 100%; border-radius: 12px;
          object-fit: cover; height: 220px; display: block;
        }
        .bs-img-grid figcaption {
          font-size: 12.5px; color: #7a9aaa;
          margin-top: 8px; font-style: italic;
        }

        /* SHARE & TAGS */
        .bs-footer-bar {
          display: flex; align-items: center; justify-content: space-between;
          flex-wrap: wrap; gap: 16px;
          padding: 28px 0; margin-top: 12px;
          border-top: 1px solid #e8eef1;
          border-bottom: 1px solid #e8eef1;
        }
        .bs-share-label {
          font-size: 11px; font-weight: 600;
          color: #294b5a; margin-right: 12px;
        }
        .bs-social-btn {
          width: 36px; height: 36px; border-radius: 10px;
          display: inline-flex; align-items: center; justify-content: center;
          border: 1.5px solid rgba(41,75,90,0.18);
          color: #294b5a; transition: all 0.2s;
          text-decoration: none;
        }
        .bs-social-btn:hover { background: #294b5a; color: #fff; border-color: #294b5a; }
        .bs-tag-pill {
          display: inline-block; padding: 5px 16px;
          border-radius: 30px; font-size: 12px; font-weight: 500;
          color: #294b5a; border: 1.5px solid rgba(41,75,90,0.2);
          background: transparent; text-decoration: none;
          transition: all 0.2s; text-transform: capitalize;
        }
        .bs-tag-pill:hover { background: #294b5a; color: #fff; border-color: #294b5a; }

        /* AUTHOR */
        .bs-author {
          display: flex; gap: 24px; align-items: flex-start;
          background: #faf8f3; border-radius: 16px;
          padding: 32px; margin: 40px 0;
          border-left: 4px solid #D3BE76;
        }
        .bs-author img {
          width: 72px; height: 72px; border-radius: 50%;
          object-fit: cover; min-width: 72px;
        }
        .bs-author__name {
          font-size: 20px; font-weight: 700; color: #1a2f38;
          margin-bottom: 3px;
        }
        .bs-author__role {
          font-size: 12px; color: #7a9aaa; font-weight: 500;
          margin-bottom: 10px;
        }
        .bs-author__bio { font-size: 14px; color: #4a6370; line-height: 1.7; }

        /* PREV / NEXT */
        .bs-nav {
          display: grid; grid-template-columns: 1fr auto 1fr;
          gap: 20px; align-items: center;
          padding: 32px 0; border-bottom: 1px solid #e8eef1;
        }
        .bs-nav__arrow {
          text-decoration: none; transition: opacity 0.2s;
        }
        .bs-nav__arrow:hover { opacity: 0.7; }
        .bs-nav__direction {
          font-size: 10px; font-weight: 600; 
          color: #D3BE76; margin-bottom: 6px;
          display: flex; align-items: center; gap: 8px;
        }
        .bs-nav__title {
          font-size: 16px; font-weight: 600; color: #1a2f38;
          line-height: 1.4;
        }
        .bs-nav__center { text-align: center; color: #c0cdd2; font-size: 22px; }

        /* REVIEWS */
        .bs-section-title {
          font-size: 28px; font-weight: 700;
          color: #1a2f38; margin-bottom: 28px;
          position: relative; padding-bottom: 14px;
        }
        .bs-section-title::after {
          content: ''; position: absolute;
          bottom: 0; left: 0; width: 40px;
          height: 2px; background: #D3BE76;
        }
        .bs-review {
          padding: 28px 0; border-bottom: 1px solid #eef1f3;
        }
        .bs-review:last-of-type { border-bottom: none; }
        .bs-review__header {
          display: flex; align-items: center; gap: 14px; margin-bottom: 14px;
        }
        .bs-review__avatar {
          width: 46px; height: 46px; border-radius: 50%; object-fit: cover;
        }
        .bs-review__name { font-size: 15px; font-weight: 600; color: #1a2f38; }
        .bs-review__date { font-size: 12px; color: #7a9aaa; margin-top: 2px; }
        .bs-review__score {
          display: inline-flex; align-items: center; gap: 6px;
          background: rgba(41,75,90,0.07); color: #294b5a;
          font-size: 13px; font-weight: 700;
          padding: 4px 12px; border-radius: 30px;
          margin-bottom: 10px;
        }
        .bs-review__score::before { content: '★'; color: #D3BE76; }
        .bs-review__text { font-size: 14.5px; color: #4a6370; line-height: 1.75; }
        .bs-review__actions { display: flex; gap: 20px; margin-top: 14px; }
        .bs-review__action {
          display: flex; align-items: center; gap: 6px;
          font-size: 13px; font-weight: 500; cursor: pointer;
          border: none; background: none; padding: 0;
          transition: color 0.2s;
        }
        .bs-review__action.helpful { color: #294b5a; }
        .bs-review__action.helpful:hover { color: #D3BE76; }
        .bs-review__action.nothelpful { color: #aabec7; }
        .bs-review__action.nothelpful:hover { color: #294b5a; }

        /* COMMENT FORM */
        .bs-form-input {
          position: relative; margin-bottom: 0;
        }
        .bs-form-input input,
        .bs-form-input textarea {
          width: 100%; padding: 18px 16px 8px;
          border: 1.5px solid #e0e8ec; border-radius: 12px;
          font-size: 14.5px;
          color: #1a2f38; outline: none; background: #faf8f3;
          transition: border-color 0.2s, box-shadow 0.2s;
          resize: none;
        }
        .bs-form-input input:focus,
        .bs-form-input textarea:focus {
          border-color: #294b5a;
          box-shadow: 0 0 0 3px rgba(41,75,90,0.07);
          background: #fff;
        }
        .bs-form-input label {
          position: absolute; left: 16px; top: 14px;
          font-size: 13px; color: #7a9aaa; font-weight: 400;
          pointer-events: none; transition: all 0.2s;
        }
        .bs-form-input input:focus ~ label,
        .bs-form-input input:valid ~ label,
        .bs-form-input textarea:focus ~ label,
        .bs-form-input textarea:valid ~ label {
          top: 5px; font-size: 10px; 
          color: #294b5a;
        }
        .bs-submit-btn {
          display: inline-flex; align-items: center; gap: 12px;
          padding: 0 36px; height: 50px; border-radius: 12px;
          background: #294b5a; color: #fff; border: none;
          font-size: 13px;
          font-weight: 600; 
          cursor: pointer;
          transition: background 0.2s, transform 0.2s;
        }
        .bs-submit-btn:hover { background: #1a2f38; transform: translateY(-1px); }
        .bs-submit-btn::after { content: '→'; font-size: 16px; }

        /* RELATED SLIDER */
        .bs-related { background: #faf8f3; padding: 80px 0; }
        .bs-related-eyebrow {
          display: flex; align-items: center; gap: 10px;
          font-size: 11px; font-weight: 600; 
          color: #D3BE76; margin-bottom: 12px;
        }
        .bs-related-eyebrow::before {
          content: ''; width: 28px; height: 1.5px; background: #D3BE76; display: block;
        }
        .bs-related-title {
          font-size: 36px; font-weight: 700; color: #1a2f38;
          margin-bottom: 40px;
        }
        .bs-rel-card {
          border-radius: 14px; overflow: hidden;
          background: #fff; text-decoration: none;
          display: block; margin: 0 10px;
          border: 1px solid #e8eef1;
          transition: box-shadow 0.3s, transform 0.3s;
        }
        .bs-rel-card:hover {
          box-shadow: 0 12px 36px rgba(41,75,90,0.1);
          transform: translateY(-3px);
        }
        .bs-rel-card__img {
          height: 180px; overflow: hidden; position: relative;
        }
        .bs-rel-card__img img {
          width: 100%; height: 100%; object-fit: cover;
          transition: transform 0.5s;
        }
        .bs-rel-card:hover .bs-rel-card__img img { transform: scale(1.06); }
        .bs-rel-card__body { padding: 18px 20px 22px; }
        .bs-rel-card__tag {
          font-size: 9px; 
          font-weight: 700; 
          color: #D3BE76; 
          margin-bottom: 8px;
        }
        .bs-rel-card__title {
          font-size: 18px; font-weight: 700; color: #1a2f38;
          line-height: 1.35; margin-bottom: 8px;
          transition: color 0.2s;
        }
        .bs-rel-card:hover .bs-rel-card__title { color: #294b5a; }
        .bs-rel-card__date { font-size: 12px; color: #7a9aaa; }

        @media (max-width: 768px) {
          .bs-hero { height: 360px; }
          .bs-img-grid { grid-template-columns: 1fr; }
          .bs-nav { grid-template-columns: 1fr 1fr; }
          .bs-nav__center { display: none; }
          .bs-author { flex-direction: column; }
        }
      `}</style>

      <div className="bs-page">
        <div className="header-margin"></div>
        <DefaultHeader />

        {/* ── HERO ── */}
        <section className="bs-hero">
          <img className="bs-hero__img" src={blog?.img} alt={blog?.title} />
          <div className="bs-hero__overlay"></div>
          <div className="bs-hero__content">
            <div className="container">
              <div className="bs-hero__tag">{blog?.tag}</div>
              <h1>{blog?.title}</h1>
              <div className="bs-hero__meta">
                <span>Brooklyn Simmons</span>
                <span className="bs-hero__meta-dot"></span>
                <span>{blog?.date}</span>
                <span className="bs-hero__meta-dot"></span>
                <span>8 min read</span>
              </div>
            </div>
          </div>
        </section>

        {/* ── ARTICLE ── */}
        <section className="bs-layout">
          <div className="container">
            <div className="row justify-center">
              <div className="col-xl-8 col-lg-10">
                <div className="bs-content">

                  {/* BODY */}
                  <div className="bs-body" data-aos="fade-up">
                    <h3>What makes a good brand book?</h3>
                    <p>
                      Sed viverra ipsum nunc aliquet bibendum enim facilisis gravida. Diam
                      phasellus vestibulum lorem sed risus ultricies. Magna sit amet purus
                      gravida quis blandit. Arcu cursus vitae congue mauris. Nunc mattis enim
                      ut tellus elementum sagittis vitae et leo.
                    </p>
                    <ul>
                      <li>Sed viverra ipsum nunc aliquet bibendum enim facilisis gravida.</li>
                      <li>At urna condimentum mattis pellentesque id nibh. Laoreet non curabitur</li>
                      <li>Magna etiam tempor orci eu lobortis elementum.</li>
                      <li>Bibendum est ultricies integer quis. Semper eget duis at tellus.</li>
                    </ul>

                    <div className="bs-quote" data-aos="fade-up">
                      <div className="bs-quote__mark">"</div>
                      <p>
                        Sed viverra ipsum nunc aliquet bibendum enim facilisis gravida. Diam
                        phasellus vestibulum lorem sed risus ultricies. Magna sit amet purus
                        gravida quis blandit. Arcu cursus vitae congue mauris.
                      </p>
                    </div>

                    <p>
                      Donec purus posuere nullam lacus aliquam egestas arcu. A egestas a,
                      tellus massa, ornare vulputate. Erat enim eget laoreet ullamcorper
                      lectus aliquet nullam tempus id. Dignissim convallis quam aliquam
                      rhoncus, lectus nullam viverra.
                    </p>

                    <div className="bs-img-grid" data-aos="fade-up">
                      <figure>
                        <img src="/img/blog/single/2.png" alt="Travel scene" />
                        <figcaption>Donec purus posuere nullam lacus aliquam.</figcaption>
                      </figure>
                      <figure>
                        <img src="/img/blog/single/3.png" alt="Travel scene" />
                        <figcaption>Donec purus posuere nullam lacus aliquam.</figcaption>
                      </figure>
                    </div>

                    <p>
                      Neque nulla porta ut urna rutrum. Aliquam cursus arcu tincidunt mus
                      dictum sit euismod cum id. Dictum integer ultricies arcu fermentum
                      fermentum sem consectetur. Consectetur eleifend aenean eu neque euismod
                      amet parturient turpis vitae. Faucibus ipsum felis et duis fames.
                    </p>
                  </div>

                  {/* SHARE & TAGS */}
                  <div className="bs-footer-bar" data-aos="fade-up">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span className="bs-share-label">Share</span>
                      {socialContent.map((item) => (
                        <a
                          key={item.id}
                          href={item.link}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="bs-social-btn"
                          style={{ marginRight: 8 }}
                          aria-label={item.label}
                        >
                          <i className={`${item.icon}`} style={{ fontSize: 14 }} />
                        </a>
                      ))}
                    </div>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                      {blogsData.slice(0, 3).map((item) => (
                        <a
                          key={item.id}
                          href={`/blog-details/${item.id}`}
                          className="bs-tag-pill"
                        >
                          {item.tag}
                        </a>
                      ))}
                    </div>
                  </div>

                  {/* AUTHOR */}
                  <div className="bs-author" data-aos="fade-up">
                    <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=200&q=80" alt="Author" />
                    <div>
                      <div className="bs-author__name">Brooklyn Simmons</div>
                      <div className="bs-author__role">Travel Writer</div>
                      <p className="bs-author__bio">
                        Etiam vitae leo et diam pellentesque porta. Sed eleifend ultricies
                        risus, vel rutrum erat commodo ut. Praesent finibus congue euismod.
                        Nullam scelerisque massa vel augue placerat.
                      </p>
                    </div>
                  </div>

                  {/* PREV / NEXT */}
                  <div className="bs-nav">
                    <a href="#" className="bs-nav__arrow">
                      <div className="bs-nav__direction">
                        <i className="icon-arrow-left" style={{ fontSize: 11 }}></i>
                        Previous
                      </div>
                      <div className="bs-nav__title">
                        5 awesome steps to get rid of stress and routine
                      </div>
                    </a>
                    <div className="bs-nav__center">· · ·</div>
                    <a href="#" className="bs-nav__arrow" style={{ textAlign: "right" }}>
                      <div className="bs-nav__direction" style={{ justifyContent: "flex-end" }}>
                        Next
                        <i className="icon-arrow-right" style={{ fontSize: 11 }}></i>
                      </div>
                      <div className="bs-nav__title">
                        Happy clients leave positive feedback less often
                      </div>
                    </a>
                  </div>

                  {/* REVIEWS */}
                  <div style={{ paddingTop: 40 }} data-aos="fade-up">
                    <div className="bs-section-title">Guest Reviews</div>

                    <div className="bs-review">
                      <div className="bs-review__header">
                        <img className="bs-review__avatar" src="https://ui-avatars.com/api/?name=Ahmed+Al+Rashid&background=294b5a&color=D3BE76&size=200&font-size=0.4&bold=true" alt="Tonko" />
                        <div>
                          <div className="bs-review__name">Tonko</div>
                          <div className="bs-review__date">March 2022</div>
                        </div>
                      </div>
                      <div className="bs-review__score">9.2 Superb</div>
                      <p className="bs-review__text">
                        Nice two level apartment in great London location. Located in quiet
                        small street, but just 50 meters from main street and bus stop.
                      </p>
             
                      <div className="bs-review__actions">
                        <button className="bs-review__action helpful">
                          <i className="icon-like" style={{ fontSize: 15 }} /> Helpful
                        </button>
                        <button className="bs-review__action nothelpful">
                          <i className="icon-dislike" style={{ fontSize: 15 }} /> Not helpful
                        </button>
                      </div>
                    </div>

                    <div className="bs-review">
                      <div className="bs-review__header">
                        <img className="bs-review__avatar" src="https://ui-avatars.com/api/?name=Ahmed+Al+Rashid&background=294b5a&color=D3BE76&size=200&font-size=0.4&bold=true" alt="Tonko" />
                        <div>
                          <div className="bs-review__name">Tonko</div>
                          <div className="bs-review__date">March 2022</div>
                        </div>
                      </div>
                      <div className="bs-review__score">9.2 Superb</div>
                      <p className="bs-review__text">
                        Nice two level apartment in great London location. Located in quiet
                        small street, but just 50 meters from main street and bus stop.
                      </p>
                      <div className="bs-review__actions">
                        <button className="bs-review__action helpful">
                          <i className="icon-like" style={{ fontSize: 15 }} /> Helpful
                        </button>
                        <button className="bs-review__action nothelpful">
                          <i className="icon-dislike" style={{ fontSize: 15 }} /> Not helpful
                        </button>
                      </div>
                    </div>

                    <div style={{ paddingTop: 24 }}>
                      <a
                        href="#"
                        style={{
                          display: "inline-flex", alignItems: "center", gap: 10,
                          padding: "10px 24px", borderRadius: 10,
                          border: "1.5px solid rgba(41,75,90,0.25)",
                          color: "#294b5a", fontSize: 13, fontWeight: 600,
                          textDecoration: "none",  transition: "all 0.2s"
                        }}
                      >
                        Show all 116 reviews
                        <i className="icon-arrow-top-right" style={{ fontSize: 14 }}></i>
                      </a>
                    </div>
                  </div>

                  {/* COMMENT FORM */}
                  <div style={{ marginTop: 40, borderTop: "1px solid #e8eef1" }} data-aos="fade-up">
                    <div className="bs-section-title">Leave a Reply</div>
                    <p style={{ fontSize: 14, color: "#7a9aaa", marginTop: -16, marginBottom: 32 }}>
                      Your email address will not be published.
                    </p>

                    <form>
                      <div className="row y-gap-24">
                        <div className="col-md-6">
                          <div className="bs-form-input">
                            <input type="text" required />
                            <label>Full Name</label>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="bs-form-input">
                            <input type="email" required />
                            <label>Email Address</label>
                          </div>
                        </div>
                        <div className="col-12 mt-3">
                          <div className="bs-form-input">
                            <textarea required rows={6} defaultValue="" />
                            <label>Write Your Comment</label>
                          </div>
                        </div>
                        <div className="col-auto">
                          <button type="submit" className="bs-submit-btn">
                            Post Comment
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ── RELATED ── */}
        <section className="bs-related">
          <div className="container">
            <div className="bs-related-eyebrow">Related Content</div>
            <div className="bs-related-title">You might also enjoy</div>
            <Slider
              slidesToShow={4}
              slidesToScroll={1}
              infinite={true}
              autoplay={true}
              autoplaySpeed={2800}
              arrows={false}
              dots={false}
              responsive={[
                { breakpoint: 1200, settings: { slidesToShow: 3 } },
                { breakpoint: 992, settings: { slidesToShow: 2 } },
                { breakpoint: 576, settings: { slidesToShow: 1 } },
              ]}
            >
              {blogsData.slice(0, 8).map((item) => (
                <div key={item.id}>
                  <a href={`/blog-details/${item.id}`} className="bs-rel-card">
                    <div className="bs-rel-card__img">
                      <img src={item.img} alt={item.title} />
                    </div>
                    <div className="bs-rel-card__body">
                      {item.tag && <div className="bs-rel-card__tag">{item.tag}</div>}
                      <div className="bs-rel-card__title">{item.title}</div>
                      <div className="bs-rel-card__date">{item.date}</div>
                    </div>
                  </a>
                </div>
              ))}
            </Slider>
          </div>
        </section>

        <DefaultFooter />
      </div>
    </>
  );
};

export default BlogSingle;